import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=63e26fcb&scoped=true&lang=pug"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e26fcb",
  null
  
)

export default component.exports